import { render } from "./BackofficeNew.vue?vue&type=template&id=bbc87870&scoped=true"
import script from "./BackofficeNew.vue?vue&type=script&lang=js"
export * from "./BackofficeNew.vue?vue&type=script&lang=js"

import "./BackofficeNew.vue?vue&type=style&index=0&id=bbc87870&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc87870"]])

export default __exports__